module.exports = __webpack_public_path__ + "static/media/website-15.b367eb44.mp4";